<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">{{ $t("EaaAccounts.Store_Account")}}</h4>
              </div>
              <div class="card-body">
                <el-row :gutter="20">
                  
                  <el-col :span="6">
                    <el-input v-model="filters[0].value" :placeholder="$t('EaaAccounts.Message.Search')" prefix-icon="el-icon-search"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <router-link v-if="userType === 'si'" to="./eaa-accounts/new" type="success">
                      <el-button type="success" round plain>{{$t('EaaAccounts.Message.Create_Account')}}</el-button>
                    </router-link>
                  </el-col>
                  <el-col :span="10">
                   
                    <el-select
                      class="select-warning"
                      style="width: 120px; margin: 5px 0 0 0;"
                      size="small"
                      :placeholder="$t('EaaAccounts.Message.Select_SI')"
                      v-if="userType === 'gaa'"
                      v-model="batchUpdateToSi"
                    >
                      <el-option
                        v-for="option of siAccounts"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                        v-if="userType === 'gaa'"
                      ></el-option>
                    </el-select>
                    <el-button type="success" size="small" :disabled="!batchUpdateToSi" @click.native="batchUpdateEaaSi()" round plain>{{$t('EaaAccounts.Message.Update_SI_for_selected_EAA', { key: siAccountMap[batchUpdateToSi]} )}}</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                  <data-tables :data="data" :filters="filters">
                    <el-table-column :label="$t('EaaAccounts.Select')" prop="id" sortable="custom">
                      <template slot-scope="scope">
                        <div class="checkbox-radios">
                          <checkbox
                            v-model="scope.row.selected"
                            class="pull-left"
                            name="subscribe"
                          ></checkbox>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-for="title in titles"
                      :prop="title.prop"
                      :label="title.label"
                      :key="title.prop"
                      sortable="custom"
                    ></el-table-column>
                    <el-table-column :label="$t('EaaAccounts.Action')" min-width="200px">
                      <template slot-scope="scope">
                        <el-button
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.name"
                          :type="button.props.type"
                          :icon="button.props.icon"
                          :class="button.style"
                          @click="button.handler"
                          round
                          size="small"
                        >{{ button.name }}</el-button>
                      </template>
                    </el-table-column>
                  </data-tables>
                  </el-col>
                </el-row>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { Checkbox, Radio } from "src/components/index";

export default {
  components: {
    Checkbox,
    Radio
  },
  data() {
    return {
      data: [],
      // actionCol: {
      //   label: "操作",
      //   props: {
      //     align: "center"
      //   },
      //   buttons: [
      //     {
      //       props: {
      //         type: "danger",
      //         icon: "el-icon-edit"
      //       },
      //       label: "更新帳密",
      //       handler: row => {
      //         console.log("the row is ", row);
      //         this.$router.push(`/eaa-accounts/${row.id}/edit`);
      //       }
      //     },
      //     {
      //       props: {
      //         type: "default",
      //         icon: "el-icon-edit"
      //       },
      //       label: "管理商店",
      //       handler: row => {
      //         console.log("the row is ", row);
      //         this.$router.push(`/eaa-accounts/${row.id}/shops`);
      //       }
      //     }
      //   ]
      // },
      siAccounts: [],
      siAccountMap: {},
      batchUpdateToSi: null,
      filters: [
        // {
        //   value: "",
        //   prop: "name"
        // },
        {
          value: "",
          prop: ["id", "name", "email"]
        }
      ]
    };
  },
  computed: {
    userType: function() {
      return this.$store.getters.userType;
    },
    titles() {
      return [
        {
          prop: "id",
          label: this.$t('EaaAccounts.Number')
        },
        {
          prop: "name",
          label: this.$t('EaaAccounts.Name')
        },
        {
          prop: "email",
          label: this.$t('EaaAccounts.Email')
        },
        {
          prop: "siName",
          label: this.$t('EaaAccounts.Distributor')
        },
        {
          prop: "createdAt",
          label: this.$t('EaaAccounts.Creation_Time')
        },
        {
          prop: "updatedAt",
          label: this.$t('EaaAccounts.Update_Time')
        }
      ]
    },
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    customButtonsForRow(row) {
      return [
        {
          name: this.$t('EaaAccounts.Update_Account_Password'),
          props: {
            type: "warning",
            icon: "el-icon-edit"
          },
          style: 'mt-2',
          handler: _ => {
            this.$router.push(`/eaa-accounts/${row.id}/edit`);
          }
        },
        {
          name: this.$t('EaaAccounts.Authorized_Store'),
          props: {
            type: "default",
            icon: "el-icon-setting"
          },
          style: 'mt-2',
          handler: _ => {
            this.$router.push(`/eaa-accounts/${row.id}/shops`);
          }
        },
        {
          name: this.$t('EaaAccounts.Delete_Account'),
          props: {
            type: "danger",
            icon: "el-icon-delete"
          },
          style: 'mt-2',
          handler: _ => {
            this.$confirm(`確定要刪除${row.name}帳號嗎？`, '警告', {
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              const apiUrl = row.siId 
                ? `${process.env.VUE_APP_APIHOST}/si/eaa-accounts/${row.id}`
                : `${process.env.VUE_APP_APIHOST}/${this.userType}/eaa-accounts/${row.id}`;

              axios.request({
                url: apiUrl,
                method: 'delete',
                data: {
                  email: row.email
                }
              })
              .then(response => {
                this.getEaaAccounts();
                this.$message({
                  type: 'success',
                  message: `${row.name}帳號已刪除。`
                });
              })
              .catch(err => {
                this.$message.error(`無法刪除${row.name}帳號，請稍後重試。`);
              });
            })
            .catch(() => {
            });
          }
        }
      ];
    },
    batchUpdateEaaSi() {
      let self = this;
      // console.log('the selected si ' + JSON.stringify(this.batchUpdateToSi));
      let eaaAccountIds = [];
      for (let i = 0; i < this.data.length; ++i) {
        if (this.data[i] && this.data[i].selected) {
          eaaAccountIds.push(this.data[i].id);
        }
      }
      console.log('the eaaAccounts ' + JSON.stringify(eaaAccountIds));
      return axios.post(`${process.env.VUE_APP_APIHOST}/${this.userType}/si-accounts/${this.batchUpdateToSi}/eaas`, 
        eaaAccountIds
      )
      .then(response => {
        console.log('done');
        return self.getEaaAccounts();
      })
      .catch(e => {
        console.log('failed ' + e.stack);
      });
    },
    getSiAccounts() {
      return axios
      .get(`${process.env.VUE_APP_APIHOST}/${this.userType}/si-accounts`)
      .then(response => {
        
        this.siAccounts = response.data;
        this.siAccountMap = {};
        for (let i = 0; i < this.siAccounts.length; ++i) {
          this.siAccountMap[this.siAccounts[i].id] = this.siAccounts[i].name;
        }
        // console.log('si accounts ' + JSON.stringify(this.siAccounts));
        return response.data;
      });
    },
    getEaaAccounts() {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/${this.userType}/eaa-accounts`)
        .then(response => {
          this.data = response.data;
          for (let a of this.data) {
            a.createdAt = a.createdTs
              ? moment.unix(a.createdTs).format("YYYY-MM-DD HH:mm:ss Z")
              : "";
            a.updatedAt = a.updatedTs
              ? moment.unix(a.updatedTs).format("YYYY-MM-DD HH:mm:ss Z")
              : "";
          }
          return response.data;
        });
    }
  },
  mounted() {
    this.getEaaAccounts();
    if (this.userType === 'gaa') {
      this.getSiAccounts();
    }
    
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.kay-data-table .sc-table .pagination-wrap {
  overflow:auto;
}
</style>